import {get} from 'lodash';
import {useEffect} from 'react';
import {useRecoilValueLoadable} from 'recoil';
import {useStore} from 'zustand';
import {useEventBus} from '../../../../../hooks/useEventBus';
import {LoadableHelpers} from '../../../../../shared/helpers/loadableHelpers';
import {dashboardSecondaryChartQuery} from '../../../../../store/reports/selectors';
import {PERIOD_VALUES} from '../constants/period';
import {STATUS_VALUES} from '../constants/status';
import {useSecondaryChartsDataStore} from '../store/useSecondaryChartsDataStore';
import {useStoresContext} from './useStoresContext';

export const useSecondaryChartDataGate = (serviceType: string) => {
  const {
    secondaryChartsFiltersStore: secondaryState,
    primaryChartsFiltersStore: primaryState,
    dashboardArchiveFilterStore,
  } = useStoresContext(serviceType);
  const bus = useEventBus();
  const period = useStore(primaryState, ({period}) => PERIOD_VALUES[period]);
  const from = useStore(primaryState, ({customPeriodStart}) => customPeriodStart);
  const to = useStore(primaryState, ({customPeriodEnd}) => customPeriodEnd);
  const status = useStore(secondaryState, ({status}) => get(STATUS_VALUES, status));
  const archived = useStore(dashboardArchiveFilterStore, (s) => s.archived);
  const data = useRecoilValueLoadable(
    dashboardSecondaryChartQuery({period, status, from, to, serviceType, isArchive: archived ? true : undefined}),
  );

  const {setContracts, setIsLoading} = useSecondaryChartsDataStore();

  useEffect(() => {
    LoadableHelpers.handle(data, {
      success: (content) => setContracts(content),
      loading: () => setIsLoading(true),
      error: (key, payload) => {
        setIsLoading(false);
        bus?.emit(key, payload);
      },
    });
  }, [bus, data, setContracts, setIsLoading]);
};
